import { environment } from 'src/environment';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { SettingsService, BaseService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import * as $ from 'jquery';
import { PlanService } from 'src/app/core/services/plan.service';
import { CommonModule, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ApplicationService } from 'src/app/core/services/application.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.scss',],
  standalone: true,
  imports: [NgClass, CommonModule, RouterModule]
})
export class BillingHistoryComponent implements OnInit {

  @Input() updateBillingContent: boolean;
  paidVideos = [];
  paidvodLength = 0;
  subscriptions = [];
  subscriptionLength = 0;
  voucherHistory = [];
  voucherLength = 0;
  amount: any;
  selectedTab: any;
  billingData: any
  selectedData: any
  paymentTypes: any;

  skinName = environment.skinName;
  noDataText: any;
  isMobile: any;

  constructor(public settingsService: SettingsService, private applicationService: ApplicationService,
    private subscriptionService: SubscriptionService, private baseService: BaseService, public planService:PlanService,
    public configService: ConfigurationService, private storageService: StorageService, private analyticsService: InhouseAnalyticsService) { }

  ngOnChanges() {
    if(this.updateBillingContent == true || this.updateBillingContent == false)
      this.ngOnInit();
  }
  ngOnInit(): void {
    const eventObj = {
      event_type: 'Page View',
      event_name: 'Billing History Page View',
      event_status: 'Success',
    };
    this.analyticsService.trackUserActions(eventObj);

    this.settingsService.showHeader = true;
    this.settingsService.showFooter = true
    this.baseService.loaderSource.next(true);
    this.billingData = {};
    this.isMobile = this.baseService.isMobileOrNot();
    const { isSvodEnabled, isTvodEnabled } = this.settingsService;
    const localeKeys = this.configService.localeKeys || {};
    this.paymentTypes = Object.entries({
      subscriptions: isSvodEnabled ? localeKeys['account.billing_subscriptions.button'] || 'Subscriptions' : undefined,
      rentals: isTvodEnabled ? localeKeys['account.billing_rentals.button'] || 'Rentals' : undefined,
      purchases: isTvodEnabled ? localeKeys['account.billing_purchases.button'] || 'Purchases' : undefined
    }).filter(([, value]) => value !== undefined);
    if(this.planService.plansLength>0){
      this.subscriptionService.userPayments().subscribe((data) => {
        this.billingData = data;
        this.baseService.loaderSource.next(false);
        this.selectedTab = 'subscriptions';
        this.selectTab(this.selectedTab);
      });
    }
  }


  display_content(id) {
    if (this.selectedTab !== id) {
      this.selectedTab = id;
      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');
      $("#" + id).addClass('current');
    }
  }

  selectTab(type) {
    this.selectedTab = type;
    this.selectedData = {};
    this.noDataText = {};
    if (this.selectedTab  === 'subscriptions') {
      const headerArr = [
        (this.configService.localeKeys?.['bil_his_desc_subsc_plan_def'] || 'Subscription Plan'),
        (this.configService.localeKeys?.['bil_his_desc_service_prd_def'] || 'Service Period'),
        (this.configService.localeKeys?.['bil_his_desc_next_due_date_def'] || 'Next Due Date'),
        (this.configService.localeKeys?.['bil_his_desc_pmnt_prcsor_def'] || 'Payment processor'),
        (this.configService.localeKeys?.['bil_his_desc_trans_no_def'] || 'Transaction Number'),
        (this.configService.localeKeys?.['billing_history.amount.text'] || 'Amount')
      ];
      this.selectedData.headerData = headerArr;
      this.selectedData.paymentData = this.billingData?.subscription_payments;
      if (!this.billingData?.subscription_payments?.length) {
        const voucherInfo = this.storageService.getLocalStore('voucherInfo');
        this.noDataText.textOne = voucherInfo ? voucherInfo : this.configService.localeKeys?.['account.no_subscriptions_error.text'] || 'You currently do not have any subscriptions.';
        this.noDataText.textTwo = '';
      }
    } else if (this.selectedTab === 'rentals') {
      const headerArr = [
        (this.configService.localeKeys?.['account.content_name.text'] || 'Content Name'),
        (this.configService.localeKeys?.['account.rented_date.text'] || 'Rented Date'),
        (this.configService.localeKeys?.['account.expiry_date.text'] || 'Expiry Date'),
        (this.configService.localeKeys?.['bil_his_desc_pmnt_prcsor_def'] || 'Payment processor'),
        (this.configService.localeKeys?.['bil_his_desc_trans_no_def'] || 'Transaction Number'),
        (this.configService.localeKeys?.['billing_history.amount.text'] || 'Amount')
      ];
      this.selectedData.headerData = headerArr;
      this.selectedData.paymentData = this.billingData?.tvod_payments?.filter(item => { return !item.is_buy});
      this.noDataText.textOne = (this.configService?.localeKeys?.['account.no_rentals_error.text'] || 'You have not rented any content yet.');
      this.noDataText.textTwo = (this.configService.localeKeys?.['account.click_here_to_explore.part2.text'] || 'to explore');
    } else if (this.selectedTab === 'purchases') {
      const headerArr = [
        (this.configService.localeKeys?.['account.content_name.text'] || 'Content Name'),
        (this.configService.localeKeys?.['account.purchased_date.text'] || 'Purchased Date'),
        (this.configService.localeKeys?.['bil_his_desc_pmnt_prcsor_def'] || 'Payment processor'),
        (this.configService.localeKeys?.['bil_his_desc_trans_no_def'] || 'Transaction Number'),
        (this.configService.localeKeys?.['billing_history.amount.text'] || 'Amount')
      ];
      this.selectedData.headerData = headerArr;
      this.selectedData.paymentData = this.billingData?.tvod_payments?.filter(item => { return item.is_buy});
      this.noDataText.textOne = (this.configService.localeKeys?.['account.no_purchases_error.text'] || 'You have not purchased any content yet.');
      this.noDataText.textTwo = (this.configService.localeKeys?.['account.click_here_to_explore.part2.text'] || 'to explore');
    }
  }

  ngOnDestroy() {
    this.storageService.removeLocalStore('voucherInfo');
  }
  

}
